<script>
	import { hero_expanded } from './../stores.js'
</script>

<div>
	<svg on:click class:expanded={$hero_expanded}><use xlink:href="#wordmark-logo"/></svg>
</div>

<style>
	svg {
		fill: var(--c-text-on-fill);
		width: 24.85rem;
		height: 3.5rem;
		margin-top: 0.2rem;
		cursor: pointer;
		transition-property: width, height, margin-top, margin-left;
		transition-duration: 0.8s;
		transition-timing-function: var(--transition-function);
	}
	svg.expanded {
		width: 28.4rem;
		height: 4rem;
		margin-top: 0;
		margin-left: -0.5rem;
		cursor: default;
	}

	@media only screen and (max-width: 700px) {
		
		div {
			width: 6rem;
		}
		:global(#logo-wordmark) {
			display: none;
		}
  }
	
</style>